module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TC-312c36fd44ccc75b248668c14b395715.png";